import { useParams } from 'react-router'

/**
 * Extracts pathParams from current Browser URL
 * @returns Dictionary containing path params
 * @example
 * ```
 * const locationReference = useLocationReference()
 * const { organisationUUID, flowUUID } = useLocationReference()
 * ```
 */
export const useLocationReference = () => {
  const params = useParams()
  return {
    flowUUID: params?.flow_uuid ?? '',
    organisationUUID: params?.organisation_uuid ?? '',
  }
}
